export default "__VITE_ASSET__e310fd4f__"